var a={border:"S",px:"L",py:"M",radius:"M",shadow:"NONE"};export{a as default};
